import { useQuery } from '@tanstack/react-query';
import { recordsApi } from '../../lib/api.js';
import { chartQueryKey } from './helpers.js';

export function sessionQueryKey(appointmentId: string) {
  return ['company', 'records', 'session', appointmentId] as const;
}

/// A sessão do atendimento e o prontuário da cliente, lidos juntos: a página do atendimento mostra
/// os dois (ADR 0038, adendo de 2026-09-28).
export function useAppointmentRecords(
  appointmentId: string,
  clientId: string | undefined,
  enabled: boolean,
) {
  const session = useQuery({
    queryKey: sessionQueryKey(appointmentId),
    queryFn: () => recordsApi.getSession(appointmentId),
    enabled,
    retry: false,
  });
  const chart = useQuery({
    queryKey: chartQueryKey(clientId ?? ''),
    queryFn: () => recordsApi.getChart(clientId!),
    enabled: enabled && Boolean(clientId),
    retry: false,
  });
  return { session, chart };
}
